import React from 'react';
import { Section } from './ui/Section';
import { Check } from 'lucide-react';
export function ResultsSection() {
  const results = ['Menos peleas por apagar pantallas', 'Más cooperación con rutinas', 'Mejor sueño y descanso real', 'Más juego y actividad física', 'Más calma en casa', 'Padres que vuelven a sentirse líderes… sin gritar'];
  return <Section background="white" data-id="element-160">
      <div className="text-center mb-6" data-id="element-161">
        <h2 className="text-2xl font-bold text-[#1e3a5f] mb-2" data-id="element-162">
          Qué resultados esperar (realistas)
        </h2>
        <p className="text-[#2d3748] text-base" data-id="element-163">
          No voy a prometerte magia. Te prometo algo mejor:{' '}
          <strong className="text-[#dc4a3d]" data-id="element-164">estructura</strong>.
        </p>
      </div>

      <div className="bg-[#fdfbf7] p-5 rounded-xl border border-gray-100 shadow-sm" data-id="element-165">
        <p className="text-[#2d3748] mb-4 font-medium text-center text-sm" data-id="element-166">
          En 30 días, la mayoría de familias que aplica un sistema consistente
          nota:
        </p>

        <div className="grid md:grid-cols-2 gap-3" data-id="element-167">
          {results.map((result, i) => <div key={i} className="flex items-center p-2.5 bg-white rounded-lg border border-gray-100 shadow-sm" data-id="element-168">
              <div className="bg-green-100 p-1 rounded-full mr-2" data-id="element-169">
                <Check className="w-3.5 h-3.5 text-green-600" data-id="element-170" />
              </div>
              <span className="text-[#2d3748] font-medium text-sm" data-id="element-171">
                {result}
              </span>
            </div>)}
        </div>

        <div className="mt-5 p-3 bg-blue-50 rounded-lg border border-blue-100 text-center" data-id="element-172">
          <p className="text-[#1e3a5f] text-sm" data-id="element-173">
            En niños pequeños, el sistema está diseñado para acercarte a{' '}
            <strong data-id="element-174">casi 0 pantallas</strong> con sustitutos prácticos y
            rituales diarios.
          </p>
        </div>
      </div>
    </Section>;
}